<template>
  <div>
    <sidebar />
    <div class="relative md:ml-64 bg-blueGray-100">
      <SmallModal />
      <AlertModal />
      <admin-navbar />
      <header-stats />
      <div 
        style="min-height: calc(100vh - 5rem)"
        class="px-4 md:px-10 mx-auto w-full -m-24 relative z-index-10">
        <router-view />
        <footer-admin />
      </div>
    </div>
  </div>
</template>

<script>
import AdminNavbar from "@/components/Navbars/AdminNavbar.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import HeaderStats from "@/components/Headers/HeaderStats.vue";
import FooterAdmin from "@/components/Footers/FooterAdmin.vue";
import SmallModal from "@/components/Modals/SmallModal.vue";
import AlertModal from "@/components/Modals/AlertModal.vue";
import { mapMutations } from 'vuex';
import axios from 'axios';
import { API_AUTH, HEADERS_TOKEN_JSON } from '@/const/uri';

export default {
  name: "admin-layout",
  components: {
    AdminNavbar,
    Sidebar,
    HeaderStats,
    FooterAdmin,
    AlertModal,
    SmallModal,
  },
  ...mapMutations(["createUser"]),
  async checkUser() {
    await axios({
      method: "GET",
      url: API_AUTH.checkToken,
      headers: HEADERS_TOKEN_JSON(),
    })
    .then((e) => {
      this.createUser(e.data.data.user);
    })
    .catch((e) => {
      console.log(e);
      this.$router.replace({
        name: 'Login',
      });
    });
  },
};
</script>
